import { BaseModel } from './base-model.model';
import { OperacaoGarantida, DetalheOperacaoGarantida, LiberacaoOperacaoGarantida } from './operacao-garantida.model';


export class OperacaoRepasseBndes extends OperacaoGarantida {

 	public idProtocoloBNDES: string;
	public idPrograma: number;
	public nomePrograma: string;
	public idModalidadeOperacionalBndes: number;
	public idPorteClienteFinal: string;
	public tipoFGI: string; // oferecer na tela o campo Tipo de ECG, com os valores: Somado ao Saldo, Dentro do Saldo, Boleto
	public idNaturezaEmpresa: number;
	public idComplementoNaturezaEmpresa:number;
	public quantidadeMesesPrazoTotal: number; // >= 0 
	public quantidadeMesesPrazoCarencia: number; // >= 0
	public pagamentoJurosCarencia: boolean;
	public numeroCertificadoRntrc: string;	
	public taxaSpreadAgente: number;
	public taxaRemuneracaoBNDES: number;
	public taxaIntermediacaoBNDES: number;
	public taxaRemuneracaoBasicaBNDES: number;
	public taxaCustoFinanceiroAdicional: number; 
	public taxaReferencialCustoFinanceiro: number;
	public sistemaOrigem: string; // ex.: APA, BCD, N03
	public municipioInvestimento: string;
	public principalGarantiaOperacao: number;
	public percentualCobertoGarantiaPrincipal: number; // 0 a 100
	public periodicidadeAmortizacao: number;
	public composicaoGarantia: string; // oferecer comobo com: FC|FT|FR|FF|RE|TR|TT

	/*
	 * Dados que sao informados apenas no momento da contratacao.
	 */
	public sistemaCobranca: string; // oferecer uma combo com 15 ou 89
	public contratoCobranca: number; // numero de 11 digitos
	public dataPrimeiraAmortizacao: Date; // data no futuro
	public dataUltimaAmortizacao: Date; // data no futuro

	public reprocessamento: string;
}

export const TIPOS_PORTE_CLIENTE = [
   {
	id: '1',
	label: 'Média Empresa I'
   },
   {
	id: '2',
	label: 'Grande empresa'
   },
  {
	id: '3',
	label: 'Microempresa'
  },
  {
	id: '4',
	label: 'Pequena empresa'
  },
  {
	id: '5',
	label: 'Média-grande'
  },
  {
	id: '6',
	label: 'Média Empresa II'
  }
];